import React from 'react'

function SodashBargiya() {
  return (
    <div>SodashBargiya</div>
  )
}

export default SodashBargiya